import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";

import awsLogoDark from "../../../assets/amazon-web-services-logo-white.png";
import awsLogo from "../../../assets/amazon-web-services-new-square.png";
import AzureLogo from "../../../assets/azure-logo.svg";
import GCPLogo from "../../../assets/gcp-logo.svg";
import { useDarkThemeCheck } from "../../../Components/hooks/useDarkThemeCheck";

const AvailabilityChips = () => {
  const darkMode = useDarkThemeCheck();

  return (
    <>
      <Chip
        data-cy="clouddiagrams-availability-chip-aws"
        icon={<Box component="img" src={darkMode ? awsLogoDark : awsLogo} sx={{ width: 16, height: 16 }} />}
        label="Available"
        sx={{ pl: "6px", backgroundColor: "general.backgroundDark", color: "text.primary" }}
      />
      <Chip
        data-cy="clouddiagrams-availability-chip-azure"
        icon={<Box component="img" src={AzureLogo} sx={{ width: 16, height: 16 }} />}
        label="Coming soon"
        sx={{ backgroundColor: "general.backgroundDark", pl: "6px", color: "text.primary" }}
      />
      <Chip
        data-cy="clouddiagrams-availability-chip-gcp"
        icon={<Box component="img" src={GCPLogo} sx={{ width: 16, height: 16 }} />}
        label="Coming soon"
        sx={{ backgroundColor: "general.backgroundDark", pl: "6px", color: "text.primary" }}
      />
    </>
  );
};

export default AvailabilityChips;
